let url = "";
let imgurl = "";

if (window.location.host === "brij.ticketak.com") {
  url = "http://18.136.206.103:3800";
  // NEW
  // url = "http://13.234.176.118:3800";
} else if (
  window.location.host === "dev.brij.tech" ||
  window.location.host === "dev-pos-dual-display.brij.tech"
) {
  url = "http://18.136.206.103:3810";
  // NEW
  // url = "http://13.234.176.118:3810";
} else if (window.location.host === "uat.brij.tech") {
  url = "http://18.136.206.103:3811";
  // NEW
  // url = "http://13.234.176.118:3811";
} else if (window.location.host === "solapur.brij.tech") {
  url = "https://solapur-api.brij.tech"; // url = "http://18.138.243.76:3800";
} else if (window.location.host === "shringar.brij.tech:3951") {
  url = "http://shringar.brij.tech:3950";
} else if (window.location.host === "shringar.brij.tech:3961") {
  url = "http://shringar.brij.tech:3960";
} else if (window.location.host === "shringar.brij.tech:3901") {
  url = "http://shringar.brij.tech:3900";
} else if (window.location.host === "shringar.brij.tech:3502") {
  url = "http://shringar.brij.tech:3501";
} else if (window.location.host === "shringar.brij.tech:3971") {
  url = "http://shringar.brij.tech:3970";
} else if (window.location.host === "brij-gdc-3.brij.tech") {
  url = "https://cinematic-server-gdc-3.brij.tech";
} else if (window.location.host === "empire-dashboard.brij.tech") {
  url = "https://api-empire.brij.tech";
} else if (window.location.host === "brij-imaculix-1.brij.tech") {
  url = "https://cinematic-server-imaculix-1.brij.tech";
} else if (window.location.hostname === "192.168.1.189") {
  url = "http://192.168.1.189:3800";
} else if (window.location.hostname === "xanadu-dashboard.brij.tech") {
  url = "https://xanadu-api.brij.tech";
} else if (window.location.hostname === "plaza-stg-dashboard.nuviotech.co") {
  url = "https://plaza-stg-api.nuviotech.co";
} else {
  url = "http://localhost:3800";
  imgurl = "http://empire-brij-s3.s3-website.ap-south-1.amazonaws.com/";
  // url = "https://cinematic-server-imaculix-1.brij.tech";

  // Testing
  // url = "http://shringar.brij.tech:3950";
  // url = "http://shringar.brij.tech:3950";
  // url = "http://shringar.brij.tech:3950";
  //   url = "http://192.168.1.155:3800";
  // local IPS
  // url = "http://192.168.0.135:3811";
  // url = "http://192.168.1.181:3800";
  // url = "http://159.65.251.47:3900";
  // url = "http://157.230.36.254:3800";
  // Below For Brij Solapur
  // url = "http://18.136.206.103:3800";
  // UatBrijTech
  // url = "http://18.136.206.103:3811";
  // DevBrijTech
  // url = "http://18.136.206.103:3810";

  // url = "http://18.136.206.103:3801";
}

const cinemaDestination = Array.from(
  { length: process.env.NO_OF_CINEMAS || 10 },
  (e, index) => {
    return {
      cinema_id: index + 1,
      cinema_url: process.env[`CINEMA_DESTINATION_${index + 1}`],
    };
  }
);

console.log("cinemaDestination", cinemaDestination);

const cinemaDestinationReport = Array.from(
  { length: process.env.NO_OF_CINEMAS || 10 },
  (e, index) => {
    const reportUrl =
      process.env[`CINEMA_DESTINATION_${index + 1}_REPORT`];
    const defaultUrl = process.env[`CINEMA_DESTINATION_${index + 1}`];
    return {
      cinema_id: index + 1,
      cinema_url: reportUrl || defaultUrl,
    };
  }
);

console.log("cinemaDestinationReport", cinemaDestinationReport);

export const CINEMADESTINATIONS = cinemaDestination;
export const CINEMADESTINATIONSREPORT = cinemaDestinationReport;
export const BASEURL = process.env.BACKEND_URL; // url
export const IMGBASEURL = imgurl;



// WEBPACK FOOTER //
// ./src/config/index.js